import React from 'reactn';
import { CustomsStatusViewStyled } from './CustomsChargesViewStyled';
import Button from "shared-anpost-components/components/button/Button";

const CustomsChargesView = ({customsRedirectHandler}) => {
    return (
        <>
            <CustomsStatusViewStyled>
                <div className='title'>Customs charges</div>
                <span className='description'>You have pending customs charges</span>
                <Button className="bn bn--primary gtm-cta" type="button" onClick={customsRedirectHandler} text="View customs charge"></Button>
            </CustomsStatusViewStyled>
        </>
    );
};

export default CustomsChargesView;


